import React, { Component } from 'react';
import Styles from './style.css';
import { BeatLoader } from 'react-spinners';
import { cartRegister } from "../../services/cartRegister";
import { dataRegister } from "../../services/dataRegister";
import { imagesRegister } from "../../services/imagesRegister";
import { userRegister } from "../../services/userRegister";
import cx from "classnames";
import { langRegister } from "../../services/langRegister";
import { quotesRegister } from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import { salesChannelRegister } from "../../services/salesChannelRegister";
import { industriesRegister } from "../../services/industriesRegister";
import { scraperRegister } from "../../services/scraperRegister";
import Typist from "react-typist";
import BoosterHeader from "../../components/booster-header/component";
import BoosterHomeCompare from "../../components/booster-home-compare/component";
import BoosterHomeFaq from "../../components/booster-home-faq/component";
import BoosterFooter from "../../components/booster-footer/component";
import { tokenRegister } from "../../services/tokenRegister";
import ModalAutorenew from "../../components/user-campaigns-running-edit/component";
import ModalLogin from "../../components/modal-login/component";
import queryString from "query-string";
import Carousel from 're-carousel';
import IndicatorDots from '../../components/carousel-indicators/component'
import BoosterHomePrice from "../../components/booster-home-price/component";
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import BoosterHomeCampaigns from "../../components/booster-home-campaigns/component";
import { scroller, Element } from 'react-scroll'
import { carouselRegister } from "../../services/carouselRegister";
import { videoRegister } from "../../services/videoRegister";
import ModalScraperError from "../../components/modal-scraper-error/component";
import { collectedRegister } from "../../services/collectedRegister";
import { flowRegister } from "../../services/flowRegister";
import { themeRegister } from "../../services/themeRegister";
import { canvasRegister } from "../../services/canvasRegister";
import BoosterHomeCompareYL from "../../components/booster-home-compare-yl/component";
import { yieldlockRegister } from "../../services/yieldlockRegister";
import { agentRegister } from "../../services/agentRegister";

class BoosterHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search: "",
            isLoading: false,
            error: false,
            new: false,
            verified_link: null,
            listings: [],
            inhouse: false,
            reseller: false,
            user: null,
        };
    };

    componentWillMount() {
        this.mounted = true;

        //RESET STORAGE
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
        industriesRegister.remove();
        scraperRegister.remove();
        collectedRegister.remove();
        flowRegister.remove();
        quotesRegister.setView(null);
        themeRegister.remove();
        videoRegister.remove();
        carouselRegister.remove();
        canvasRegister.remove();
        yieldlockRegister.remove();
        agentRegister.remove();

        //SCROLL TOP
        window.scrollTo(0, 0);

        //UPDATE DATA
        this.update.user();
        this.update.listings();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/');
            ReactGA4.send({ hitType: "pageview", page: "/" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

        scraperRegister.setImagesAvailableBoolean(false);

    }

    componentWillUnmount() {
        this.mounted = false;
    }

    update = {
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({
                        user: user,
                        reseller: user.reseller,
                        inhouse: user.inhouse,
                        agents: Array.isArray(user.agents) ? (user.agents.length > 0) : false
                    });
                }
            } catch (error) { }
        },
        listings: () => {
            dataRegister.getScrapers().then((item) => {
                this.setState({ listings: item }, () => {
                    try {
                        let query = queryString.parse(this.props.location.search);
                        if (query.url) {
                            this.setState({ search: query.url }, () => {
                                this.scraper.check();
                                this.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                            });
                        }
                    } catch (e) { }
                });
            }, (error) => { });
        }
    };

    functions = {
        new: (url, listing_platform) => {
            if (tokenRegister.get()) {

                scraperRegister.setImagesAvailableBoolean(true);

                let scraper_object = {
                    images: [],
                    slogans: [],
                    additional_information: {
                        broker: null,
                        facts: {
                            area_sqft: null,
                            bathrooms: null,
                            bedrooms: null,
                            completion_status: null,
                            currency: null,
                            listing_platform: listing_platform,
                            listing_type: null,
                            price: null,
                            type: null
                        },
                        url: url
                    }
                };
                scraperRegister.set(scraper_object);
                if (this.state.agents) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                }
            } else {
                this.setState({ modal: true, new: true });
            }
        },
        setLoginModal: (value) => {
            this.setState({ modal_login: value });
        },
        setScraperErrorModal: (value, close) => {
            if (value) {
                this.setState({ modal_error: false, isLoading: false }, () => {
                    this.scraper.update(this.state.scraper_id, this.state.validator_id, this.state.scraper_type, this.state.url);
                });
            } else {
                if (close) {
                    this.setState({ modal_error: false, isLoading: false });
                } else {
                    let scraper_object = {
                        images: [],
                        slogans: [],
                        additional_information: {
                            broker: null,
                            facts: {
                                area_sqft: null,
                                bathrooms: null,
                                bedrooms: null,
                                completion_status: null,
                                currency: null,
                                listing_platform: null,
                                listing_type: null,
                                price: null,
                                type: null
                            },
                            url: null
                        }
                    };
                    scraperRegister.set(scraper_object);
                    if (this.state.agents) {
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                    } else {
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                    }
                }
            }
        }
    };

    scraper = {
        check: () => {
            this.setState({ isLoading: true, error: false }, () => {

                console.log(this.state.search);

                dataRegister.checkScraperLink(this.state.search, langRegister.lang()).then((response) => {
                    console.log(response);
                    if (response.scraper_id) {
                        this.setState({
                            scraper_id: response.scraper_id,
                            validator_id: response.validator_id,
                            scraper_type: response.scraper_type,
                            url: response.url
                        }, () => {
                            this.scraper.update(response.scraper_id, response.validator_id, response.scraper_type, response.url);
                        });
                    } else {
                        try {
                            this.refs.input.blur();
                        } catch (e) { }
                        setTimeout(() => {
                            if (this.state.inhouse) {
                                dataRegister.checkUrl({ url: this.state.search }).then((response) => {
                                    this.functions.new(this.state.search, "Portal");
                                }, (error) => {
                                    this.setState({ isLoading: false, error: true });
                                });
                            } else {
                                this.setState({ isLoading: false, error: true });
                            }
                        }, 100);
                    }
                }, (error) => {
                    try {
                        this.refs.input.blur();
                    } catch (e) { }
                    setTimeout(() => {
                        if (this.state.inhouse) {
                            dataRegister.checkUrl({ url: this.state.search }).then((response) => {
                                console.log(response);
                                this.setState({ isLoading: false }, () => {
                                    this.functions.new(this.state.search, "Portal");
                                });
                            }, (error) => {
                                this.setState({ isLoading: false, error: true });
                            });
                        } else {
                            this.setState({ isLoading: false, error: true });
                        }
                    }, 100);
                });
            });
        },
        update: (id, validator_id, type, url) => {
            for (let i = 0; i < this.state.listings.length; i++) {
                if (this.state.listings[i].id === id) {
                    this.state.listings[i].selected = true;
                    break;
                }
            }
            this.setState({ listings: this.state.listings, verified_link: this.state.search }, () => {
                this.scraper.get(id, validator_id, type, url);
            });
        },
        get: (id, validator_id, type, url) => {
            this.refs.input.blur();
            if (tokenRegister.get()) {
                if (this.state.reseller || this.state.inhouse) {
                    let options = {
                        method: 'GET',
                        headers: {
                            'Authorization': tokenRegister.get(),
                            'Content-Type': 'application/json',
                        }
                    };
                    fetch(dataRegister.api.primehit2 + '/' + salesChannelRegister.get('market') + "/check_session", options)
                        .then(res => {
                            if (res.status === 200) {
                                this.setState({ isLoading: true }, () => {

                                    console.log(url);

                                    dataRegister.scrapeLink(url, id, validator_id, type, langRegister.lang()).then((response) => {


                                        console.log(response);

                                        if (this.mounted) {

                                            //SET SLOGANS SELECTED
                                            try {
                                                for (let i = 0; i < response.slogans.length; i++) {
                                                    response.slogans[i].selected = true;
                                                }
                                            } catch (e) { }

                                            response.scraped = true;
                                            scraperRegister.set(response);


                                            //CHECK IF IMAGES
                                            if (salesChannelRegister.get('name') === "yieldlock") {
                                                try {

                                                    if (this.state.inhouse) {
                                                        cartRegister.setOptions("instant");
                                                        if (response.images.length < 1 || response.empty) {
                                                            scraperRegister.setImagesAvailableBoolean(true);
                                                        }
                                                        if (this.state.agents) {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                                                        } else {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
                                                        }
                                                    } else if (!this.state.inhouse && (response.images.length < 1 || response.empty) && this.state.reseller) {
                                                        for (let i = 0; i < this.state.listings.length; i++) {
                                                            this.state.listings[i].selected = false;
                                                        }
                                                        this.setState({
                                                            isLoading: false,
                                                            error: true,
                                                            listings: this.state.listings
                                                        });
                                                    } else if (!this.state.inhouse && response.images.length > 0 && this.state.reseller) {
                                                        cartRegister.setOptions("instant");
                                                        if (this.state.agents) {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                                                        } else {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
                                                        }
                                                    }

                                                    /*
                                                    if(response.images.length > 0 || response.empty){
                                                        cartRegister.setOptions("instant");
                                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
                                                    }else{
                                                        if(Array.isArray( response.images) &&  response.images.length > 0){
                                                            scraperRegister.setImagesAvailableBoolean(true)
                                                        }
                                                        this.setState({modal_error: true});
                                                    }

                                                    */
                                                } catch (e) {
                                                    console.log(e);
                                                    this.setState({ error: true, isLoading: false });
                                                }
                                            } else {

                                                try {

                                                    if (this.state.inhouse) {
                                                        if (response.images.length < 1 || response.empty) {
                                                            scraperRegister.setImagesAvailableBoolean(true);
                                                        }
                                                        if (this.state.agents) {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                                                        } else {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                                                        }
                                                    } else if (!this.state.inhouse && (response.images.length < 1 || response.empty) && this.state.reseller) {
                                                        for (let i = 0; i < this.state.listings.length; i++) {
                                                            this.state.listings[i].selected = false;
                                                        }
                                                        this.setState({
                                                            isLoading: false,
                                                            error: true,
                                                            listings: this.state.listings
                                                        });
                                                    } else if (!this.state.inhouse && response.images.length > 0 && this.state.reseller) {
                                                        if (this.state.agents) {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/agents");
                                                        } else {
                                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                                                        }
                                                    }

                                                    /*
                                                    if(response.images.length > 0){
                                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                                                    }else if(response.empty){
                                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                                                    }else{
                                                        this.setState({modal_error: true});
                                                    }

                                                     */
                                                } catch (e) {
                                                    console.log(e);
                                                    this.setState({ error: true, isLoading: false });
                                                }
                                            }

                                            /*
                                            if(salesChannelRegister.get('name') === "yieldlock"){
                                                cartRegister.setOptions("instant");
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
                                            }else{
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                                            }

                                             */


                                        }
                                    }, (error) => {
                                        for (let i = 0; i < this.state.listings.length; i++) {
                                            this.state.listings[i].selected = false;
                                        }
                                        this.setState({
                                            isLoading: false,
                                            error: true,
                                            listings: this.state.listings
                                        });
                                    });
                                });
                            } else {
                                const error = new Error(res.error);
                                throw error;
                            }
                        })
                        .catch(err => {
                            tokenRegister.remove();
                            setTimeout(() => {
                                this.setState({ isLoading: false, modal_login: true });
                            }, 500);
                        });
                } else {
                    this.setState({
                        error: true,
                        isLoading: false
                    });
                }
            } else {
                setTimeout(() => {
                    this.setState({ isLoading: false, modal_login: true });
                }, 500);
            }
        }
    };

    validators = {
        website: (value) => {
            //var re = /^(http?:\/\/|https?:\/\/)?(www\.)?([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}(\/\S*)?$/ig;
            //return re.test(String(value).toLowerCase());
            return true;
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("booster-home", item);
        },
        platform: (item) => {

            if (langRegister.lang() === "sv") {

                if (item.toLowerCase() === "portal") {

                    return "Portal";

                } else if (item.toLowerCase() === "website") {

                    return "Hemsida";

                } else if (item.toLowerCase() === "crm") {

                    return "CRM";

                }
            } else {
                return item;
            }
        }
    };

    render() {
        return (
            <div>
                <Element name="top" className="top"></Element>
                {
                    this.state.modal_login &&
                    <ModalLogin new={this.state.new} url={this.state.search} setModal={this.functions.setLoginModal} history={this.props.history} />
                }
                {
                    this.state.modal_error &&
                    <ModalScraperError setModal={this.functions.setScraperErrorModal} />
                }
                <BoosterHeader props={this.props} />
                <div className={
                    cx(Styles.header,
                        {
                            [Styles.headerPB]: salesChannelRegister.get('name') === "propertybooster",
                            [Styles.headerBB]: salesChannelRegister.get('name') === "boostabostad",
                            [Styles.headerYL]: salesChannelRegister.get('name') === "yieldlock",
                        })
                }>
                    <div className={Styles.container}>
                        <div className={Styles.headerTitle}>
                            {
                                !this.state.isLoading &&
                                <span className={Styles.headerTitleBold}>
                                    {this.renders.text("item_1")}&nbsp;
                                </span>
                            }
                            {
                                !this.state.isLoading &&
                                <span>
                                    {this.renders.text("item_2")}
                                </span>
                            }
                            {
                                this.state.isLoading &&
                                <span className={Styles.headerTitleBold}>
                                    {this.renders.text("item_3")}&nbsp;
                                </span>
                            }
                            {
                                this.state.isLoading &&
                                <Typist className={Styles.headerTitleTypist} stdTypingDelay={0} cursor={{ show: false }}>
                                    {this.renders.text("item_4")}
                                    <Typist.Backspace count={15} delay={5000} />
                                    {this.renders.text("item_5")}
                                    <Typist.Backspace count={13} delay={5000} />
                                    {this.renders.text("item_6")}
                                    <Typist.Backspace count={17} delay={5000} />
                                    {this.renders.text("item_7")}
                                </Typist>
                            }
                            {
                                !this.state.isLoading &&
                                <div className={cx(Styles.headerTitleIcons,
                                    {
                                        [Styles.headerTitleIconsYL]: salesChannelRegister.get('name') === "yieldlock",
                                    })
                                }>
                                    {
                                        salesChannelRegister.get('name') === "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img style={{ width: "100%", height: "100%" }}
                                                src={require("../../assets/images/YL_star.png")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') === "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img style={{ width: "100%", height: "100%" }}
                                                src={require("../../assets/images/YL_star.png")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') === "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img style={{ width: "100%", height: "100%" }}
                                                src={require("../../assets/images/YL_star.png")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') === "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img style={{ width: "100%", height: "100%" }}
                                                src={require("../../assets/images/YL_star.png")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') === "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img style={{ width: "100%", height: "100%" }}
                                                src={require("../../assets/images/YL_star.png")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img className={Styles.headerTitleIconsBoxGoogle}
                                                src={require("../../assets/images/google_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img className={Styles.headerTitleIconsBoxFb}
                                                src={require("../../assets/images/facebook_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img className={Styles.headerTitleIconsBoxBing}
                                                src={require("../../assets/images/bing_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox)}>
                                            <img className={Styles.headerTitleIconsBoxInstagram}
                                                src={require("../../assets/images/instagram_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox, Styles.headerTitleIconsBoxInactive)}>
                                            <img className={Styles.headerTitleIconsBoxTiktok}
                                                src={require("../../assets/images/tiktok_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        salesChannelRegister.get('name') !== "yieldlock" &&
                                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                            cx(Styles.headerTitleIconsBox, Styles.headerTitleIconsBoxInactive)}>
                                            <img className={Styles.headerTitleIconsBoxSnapchat}
                                                src={require("../../assets/images/snapchat_logo_icon.svg")} />
                                        </div>
                                    }
                                    {
                                        langRegister.lang() === "en" && salesChannelRegister.get('name') !== "yieldlock" &&
                                        <img className={Styles.notificationBadge} src={require("../../assets/images/ab_coming_soon_en.png")} />
                                    }
                                    {
                                        langRegister.lang() === "sv" && salesChannelRegister.get('name') !== "yieldlock" &&
                                        <img className={Styles.notificationBadge} src={require("../../assets/images/ab_coming_soon_sv.png")} />
                                    }
                                </div>
                            }
                        </div>
                        <div className={Styles.headerOptions}>
                            {
                                !this.state.error &&
                                this.state.listings.map((item) => {
                                    return (
                                        <div className={
                                            cx(Styles.headerOptionsItem,
                                                {
                                                    [Styles.headerOptionsItemFaded]: !item.selected,
                                                })
                                        }>
                                            {this.renders.platform(item.title)}
                                            {
                                                item.selected && !this.state.error &&
                                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={Styles.headerOptionsItemMarker} />
                                            }
                                        </div>
                                    )
                                })
                            }
                            {
                                this.state.listings.length < 1 && !this.state.error &&
                                <div className={cx(Styles.headerOptionsItem, Styles.headerOptionsItemFaded)}>
                                    {this.renders.text("item_8")}
                                </div>
                            }
                            {
                                this.state.error && (!this.state.user || (this.state.user && (this.state.inhouse || this.state.reseller))) &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#E65032' } : {}} className={cx(Styles.headerOptionsItem, Styles.headerOptionsItemError)}>
                                    {this.renders.text("item_9")}
                                </div>
                            }
                            {
                                this.state.error && (this.state.user && !this.state.inhouse && !this.state.reseller) &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#E65032' } : {}} className={cx(Styles.headerOptionsItem, Styles.headerOptionsItemError)}>
                                    {this.renders.text("item_100")}
                                </div>
                            }
                        </div>
                        <div className={Styles.headerSearch}>
                            <div className={
                                cx(Styles.headerSearchContainer,
                                    {
                                        [Styles.headerSearchInputYLLoader]: salesChannelRegister.get('name') === "yieldlock"
                                    })
                            }>
                                {
                                    salesChannelRegister.get('name') !== "yieldlock" &&
                                    <img className={Styles.headerSearchContainerFront} src={require('../../assets/images/arrow_front.png')} />
                                }
                                {
                                    <input
                                        ref={"input"}
                                        value={this.state.search}
                                        onFocus={() => this.setState({ open: true }, () => {
                                            if (window.innerWidth > 1050) {
                                                scroller.scrollTo('top', {
                                                    duration: 600,
                                                    delay: 0,
                                                    offset: 150,
                                                    smooth: 'easeInOutQuart'
                                                })
                                            }
                                        })}
                                        onChange={(event) => {
                                            console.log(event.target.value)
                                            this.setState({
                                                search: event.target.value
                                            }, () => {
                                                if (this.state.verified_link !== this.state.search) {
                                                    for (let i = 0; i < this.state.listings.length; i++) {
                                                        this.state.listings[i].selected = false;
                                                    }
                                                    this.setState({ listings: this.state.listings });
                                                }
                                                if (this.state.search === "" && this.state.error) {
                                                    this.setState({ 
                                                        error: false 
                                                    });
                                                } else if (this.validators.website(this.state.search)) {
                                                    this.scraper.check();
                                                }
                                            })
                                        }}
                                        disabled={this.state.listings.length < 1}
                                        placeholder={this.renders.text("item_21")}
                                        className={
                                            cx(Styles.headerSearchInput,
                                                {
                                                    [Styles.headerSearchInputError]: this.state.error,
                                                    [Styles.headerSearchInputErrorYL]: this.state.error && salesChannelRegister.get('name') === "yieldlock",
                                                    [Styles.headerSearchInputYL]: salesChannelRegister.get('name') === "yieldlock"
                                                })
                                        }
                                        style={salesChannelRegister.get('name') === "yieldlock" && this.state.isLoading ? { opacity: 0 } : {}}
                                    />
                                }
                                {
                                    this.state.isLoading &&
                                    <div className={
                                        cx(Styles.headerSearchContainerOverlay,
                                            {
                                                [Styles.headerSearchInputYL]: salesChannelRegister.get('name') === "yieldlock"
                                            })
                                    }>
                                        <BeatLoader size={25} color={'var(--first-color)'} loading={true} />
                                    </div>
                                }
                            </div>
                            {
                                this.state.inhouse && false &&
                                <div className={Styles.headerSearchNew}>
                                    <div onClick={() => this.functions.new()} className={Styles.headerSearchNewText}>
                                        {this.renders.text("item_10")}&nbsp;
                                        <span className={Styles.headerSearchNewTextBold}>
                                            {this.renders.text("item_11")}
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={Styles.headerTitleIconsMobile}>
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img style={{ width: "100%", height: "100%" }}
                                        src={require("../../assets/images/YL_star.png")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img style={{ width: "100%", height: "100%" }}
                                        src={require("../../assets/images/YL_star.png")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img style={{ width: "100%", height: "100%" }}
                                        src={require("../../assets/images/YL_star.png")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img style={{ width: "100%", height: "100%" }}
                                        src={require("../../assets/images/YL_star.png")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img style={{ width: "100%", height: "100%" }}
                                        src={require("../../assets/images/YL_star.png")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img className={Styles.headerTitleIconsBoxGoogle}
                                        src={require("../../assets/images/google_logo_icon.svg")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img className={Styles.headerTitleIconsBoxFb}
                                        src={require("../../assets/images/facebook_logo_icon.svg")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img className={Styles.headerTitleIconsBoxBing}
                                        src={require("../../assets/images/bing_logo_icon.svg")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox)}>
                                    <img className={Styles.headerTitleIconsBoxInstagram}
                                        src={require("../../assets/images/instagram_logo_icon.svg")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox, Styles.headerTitleIconsBoxInactive)}>
                                    <img className={Styles.headerTitleIconsBoxTiktok}
                                        src={require("../../assets/images/tiktok_logo_icon.svg")} />
                                </div>
                            }
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={
                                    cx(Styles.headerTitleIconsBox, Styles.headerTitleIconsBoxInactive)}>
                                    <img className={Styles.headerTitleIconsBoxSnapchat}
                                        src={require("../../assets/images/snapchat_logo_icon.svg")} />
                                </div>
                            }
                        </div>
                        <div className={Styles.headerTitleIconsMobile}>
                            {
                                langRegister.lang() === "en" && salesChannelRegister.get('name') !== "yieldlock" &&
                                <img className={Styles.notificationBadge} src={require("../../assets/images/ab_coming_soon_en.png")} />
                            }
                            {
                                langRegister.lang() === "sv" && salesChannelRegister.get('name') !== "yieldlock" &&
                                <img className={Styles.notificationBadge} src={require("../../assets/images/ab_coming_soon_sv.png")} />
                            }
                        </div>
                        {
                            this.state.inhouse && false &&
                            <div className={Styles.headerSearchNewMobile}>
                                <div onClick={() => this.functions.new()} className={Styles.headerSearchNewText}>
                                    {this.renders.text("item_10")}&nbsp;
                                    <span className={Styles.headerSearchNewTextBold}>
                                        {this.renders.text("item_11")}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                    {
                        salesChannelRegister.get('name') === "yieldlock" && false &&
                        <div className={Styles.headerImageYL}>
                            <img className={Styles.headerImageItemYL} src={require("../../assets/images/YL_skyline_Desktop_AE.jpg")} />
                        </div>
                    }
                    {
                        (salesChannelRegister.get('name') === "propertybooster" || salesChannelRegister.get('name') === "boostabostad") &&
                        <div className={Styles.headerImage}>
                            {
                                salesChannelRegister.get('name') === "propertybooster" &&
                                <img className={Styles.headerImageItem} src={require("../../assets/images/PB_buildings_2.png")} />
                            }
                            {
                                salesChannelRegister.get('name') === "boostabostad" &&
                                <img className={Styles.headerImageItem} src={require("../../assets/images/BB_buildings.png")} />
                            }
                        </div>
                    }
                </div>
                <div className={
                    cx(Styles.sectionOne,
                        {
                            [Styles.sectionOneYL]: salesChannelRegister.get('name') === "yieldlock",
                        })
                }>
                    <div className={Styles.sectionOneItem}>
                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={Styles.sectionOneItemPlus}>
                            <img className={Styles.sectionOneItemPlusIcon} src={require("../../assets/images/plus_sign_white_small.png")} />
                        </div>
                        <div className={Styles.sectionOneItemTitle}>
                            {this.renders.text("item_12")}
                        </div>
                        <div className={Styles.sectionOneItemSubtitle}>
                            {this.renders.text("item_13")}
                        </div>
                    </div>
                    <div className={Styles.sectionOneItem}>
                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={Styles.sectionOneItemPlus}>
                            <img className={Styles.sectionOneItemPlusIcon} src={require("../../assets/images/plus_sign_white_small.png")} />
                        </div>
                        <div className={Styles.sectionOneItemTitle}>
                            {this.renders.text("item_14")}
                        </div>
                        <div className={Styles.sectionOneItemSubtitle}>
                            {this.renders.text("item_15")}
                        </div>
                    </div>
                    <div className={Styles.sectionOneItem}>
                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { backgroundColor: '#E65032' } : {}} className={Styles.sectionOneItemPlus}>
                            <img className={Styles.sectionOneItemPlusIcon} src={require("../../assets/images/plus_sign_white_small.png")} />
                        </div>
                        <div className={Styles.sectionOneItemTitle}>
                            {this.renders.text("item_16")}
                        </div>
                        <div className={Styles.sectionOneItemSubtitle}>
                            {this.renders.text("item_17")}
                        </div>
                    </div>
                    {
                        salesChannelRegister.get('name') === "yieldlock" &&
                        <img className={Styles.sectionOneYLBottomDesktop} src={require("../../assets/images/YL_getfreelisting_Desktop_EN.png")} />
                    }
                    {
                        salesChannelRegister.get('name') === "yieldlock" &&
                        <div className={Styles.sectionOneYLBottomMobile}>
                            <img className={Styles.sectionOneYLBottomMobileImage} src={require("../../assets/images/YL_getfreelisting_Mobile_EN.png")} />
                        </div>
                    }
                </div>
                <div className={Styles.sectionTwo}>
                    {
                        salesChannelRegister.get('name') === "yieldlock" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageDesktop} src={require('../../assets/images/YL_howtoyieldlock_Desktop_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "yieldlock" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageMobile} src={require('../../assets/images/YL_howtoyieldlock_Mobile_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "propertybooster" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageDesktop} src={require('../../assets/images/pb_howto_desktop_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "propertybooster" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageMobile} src={require('../../assets/images/pb_howto_mobile_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "boostabostad" && langRegister.lang() === "en" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageDesktop} src={require('../../assets/images/BB_howtoboost_Desktop_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "boostabostad" && langRegister.lang() === "sv" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageDesktop} src={require('../../assets/images/BB_howtoboost_Desktop_SV.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "boostabostad" && langRegister.lang() === "en" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageMobile} src={require('../../assets/images/BB_howtoboost_Mobile_EN.png')} />
                    }
                    {
                        salesChannelRegister.get('name') === "boostabostad" && langRegister.lang() === "sv" &&
                        <img onClick={() => {
                            window.scrollTo(0, 0);
                        }} className={Styles.sectionTwoImageMobile} src={require('../../assets/images/BB_howtoboost_Mobile_SV.png')} />
                    }
                </div>
                <div className={cx(Styles.sectionThree)}>
                    {
                        salesChannelRegister.get('name') !== "yieldlock" &&
                        <AliceCarousel
                            autoHeight={true}
                            swipeDisabled={true}
                            dotsDisabled={true}
                            buttonsDisabled={true}
                            ref={(el) => (this.Carousel = el)}
                            responsive={{
                                0: { items: 1 },
                            }}
                        >
                            <div className={Styles.sectionThreeInner}>
                                <BoosterHomeCompare props={this.props} />
                            </div>
                            <div className={Styles.sectionThreeInner}>
                                <BoosterHomePrice props={this.props} />
                            </div>
                            <div className={Styles.sectionThreeInner}>
                                <BoosterHomeCampaigns props={this.props} />
                            </div>
                        </AliceCarousel>
                    }
                    {
                        salesChannelRegister.get('name') === "yieldlock" &&
                        <AliceCarousel
                            autoHeight={true}
                            swipeDisabled={true}
                            dotsDisabled={true}
                            buttonsDisabled={true}
                            ref={(el) => (this.Carousel = el)}
                            responsive={{
                                0: { items: 1 },
                            }}
                        >
                            <div className={Styles.sectionThreeInner}>
                                <BoosterHomeCompareYL props={this.props} />
                            </div>
                            <div className={Styles.sectionThreeInner}>
                                <BoosterHomeCampaigns props={this.props} />
                            </div>
                        </AliceCarousel>
                    }
                    <img onClick={() => this.Carousel._slidePrev()} className={Styles.sectionThreeArrowLeft}
                        src={require('../../assets/images/AB_arrow_left.png')} />
                    <img onClick={() => this.Carousel._slideNext()} className={Styles.sectionThreeArrowRight}
                        src={require('../../assets/images/AB_arrow_right.png')} />
                </div>
                <div className={Styles.sectionFour}>
                    <div style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#00273A' } : {}} className={Styles.sectionFourTitle}>
                        {this.renders.text("item_18")}
                    </div>
                    <div className={Styles.sectionFourInner}>
                        <BoosterHomeFaq />
                        <div className={cx(Styles.sectionFourInnerImageContainer)} >
                            {
                                salesChannelRegister.get('name') === "yieldlock" &&
                                <img className={cx(Styles.sectionFourInnerImage)} src={require("../../assets/images/YL_lock.png")} />
                            }
                            {
                                salesChannelRegister.get('name') === "propertybooster" &&
                                <img className={cx(Styles.sectionFourInnerImage)} src={require("../../assets/images/PB_megafon.png")} />
                            }
                            {
                                salesChannelRegister.get('name') === "boostabostad" &&
                                <img className={cx(Styles.sectionFourInnerImage)} src={require("../../assets/images/BB_megafon.png")} />
                            }
                        </div>
                    </div>
                </div>
                <div className={Styles.sectionFive}>
                    <div className={Styles.sectionFiveTitle}>
                        <span style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#E65032' } : {}}>{this.renders.text("item_19")}</span>
                        <div style={salesChannelRegister.get('name') === "yieldlock" ? { color: '#00273A' } : {}} className={Styles.sectionFiveTitleSecond}>{this.renders.text("item_22")}</div>
                    </div>
                    <div onClick={() => {
                        window.scrollTo(0, 0);
                    }} className={Styles.sectionFiveButton}>
                        {this.renders.text("item_20")}
                    </div>
                </div>
                <BoosterFooter props={this.props} history={this.props} />
            </div>
        );
    }
}

export default BoosterHome;


// WEBPACK FOOTER //
// ./src/pages/booster-home/component.js